module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Chapter One")])])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("THE PAGES OF the magazine were flipped with an impatient finger. The articles couldn't hold Leah Talbot's attention as she kept glancing at the clock on the wall above the reception desk.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Outside, the gold ball of the sun was dipping closer to the horizon. Its light cast a pale yellow hue on the wings of the small planes parked on the hangar apron outside.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The clatter of the typewriter stopped. The dark-haired woman behind the reception desk rose from her chair, turning to her co-worker, an older woman with light hair that had been rinsed to a brassy shade to conceal the gray.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Want a cup of coffee, June?\" the dark-haired woman inquired. The older woman nodded without glancing from the account books spread across her desk. With two cups in hand, the brunette walked to the waist-high counter door, deftly swinging it open with her hip.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She smiled politely at Leah. \"How about you, Miss Talbot? Would you like a refill?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Glancing at the empty Styrofoam cup sitting on the table in front of her, Leah hesitated, then shrugged, \"Why not?\" A faintly cynical grimace touched her sensually curved mouth.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Absently Leah smoothed the lightweight material of her camel tan skirt as she picked up her cup and, sidestepping her luggage, followed the woman.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Getting tired of waiting?\" The woman's question was rhetorical and sympathetic.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Breathing in deeply, Leah carried the thought further. \"And getting impatient to leave.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The glass coffee pot sat in its heated nest on a table. Several vending machines stood adjacent to it, offering snacks of candy and cold sandwiches.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You are going to visit family, aren't you?\" The woman filled Leah's cup, then turned to the two she had brought.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes, my brother Lonnie.\" The heat from the hot liquid flowed through the sides of the cup. Leah held it gingerly. Her hazel eyes turned to the windows and the slowly sinking sun. Impatiently she flicked her light brown hair behind her shoulder.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Perhaps you should telephone him and explain about the delay,\" the woman suggested.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"There's no need.\" Leah gave a brief shake of her head. \"He doesn't know I'm coming. It's a surprise for his birthday tomorrow.\" She glanced at the persistently moving hands of the dock. \"At least, I hope it will be. First I have to get there.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What's your brother doing in Austin? I mean,\" the woman laughed, \"there are quite a few other towns in Nevada I would pick first.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"His letter indicated that it wasn't a bustling metropolis,\" Leah smiled. \"He's only there temporarily, though. He works for a mining company. He's part of a team and they sent him to Austin to do some tests in the area.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The coffee pot was set back in place. \"What about the rest of your family?\" The woman picked up the cups and began wandering toward the reception counter, her gaze resting curiously on the attractive young woman walking beside her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"There's only my parents. They're in Alaska now.\" At the woman's lifted brow, Leah explained, \"Dad is in the Air Force.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That explains why someone as young as you is so accustomed to flying,\" the woman replied.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Twenty-two didn't feel so young, but it probably seemed young to the brunette, who was in her late thirties. Nor did Leah correct the woman's suggestion that she was flying from habit. Time was the key factor in her choice of transportation and it was slipping away.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"How much longer do you think it will be before we leave?\" Leah glanced at the clock, her impatience returning.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The woman shrugged, setting down one of the cups to open the counter door. \"I don't know. As soon as Mr. Smith arrives, I suppose.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The answer was hardly welcome. She had been waiting for the last two hours. His tardiness seemed to be upsetting only herself. Everyone else seemed to accept it as natural, but then he was a frequent customer of this charter flying service.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Settling on to the vinyl-covered couch, Leah acknowledged that the worst thing that could happen would be for Mr. Smith not show up. Her portion of the chartered flight to Austin had virtually emptied her meager savings account. Only by sharing the cost of plane and pilot with this Mr. Smith had she been able to afford the flight.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Luck had been sitting on her shoulder the day she had called to inquire about the price. When she had been told how much it would be, Leah had been ready to shelve the idea as too expensive. Then an inquiry as to when she wanted to go prompted the discovery that a charter flight had already been booked for that Friday with the same destination.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Leah had been on pins and needles until it was confirmed that Mr. Smith was willing to share the expense. With a sigh she admitted that the waiting wasn't over yet.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A connecting door into the waiting lounge opened and a man stuck his head inside the room. Brown hair had begun to recede from his wide forehead, creased now with a studious frown of absent concentration.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Hey, Mary, have you heard any more from Reilly since he called to say he'd be late?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Sorry, Grady.\" The brunette lifted her hands in an open-palmed gesture. \"Haven't heard a word.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He signed. \"What about my other passenger?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"She's here.\" The receptionist motioned toward Leah sitting on the couch.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("His gaze swung the width of the room to Leah. Immediately that distant look left his expression. He stepped into the room, a smile splitting his broad cheeks.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You are Miss Talbot?\" His smile deepened at Leah's answering nod. \"Well, this is a pleasant surprise. I was afraid I was going to be stuck with a toddering old maid who would be scared to death of flying.\" He thrust a large hand out to her. \"I'm Grady Thompson, your pilot.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"How do you do, Mr. Thompson,\" Leah replied as her hand was wrung in a vigorous shake.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No, make it Grady,\" the pilot insisted with a bright twinkle in his eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He was of medium height with a stocky frame. The paunch around his waist became more noticable as he sat on the couch beside her. He was in his forties, old enough to be her father, but that didn't stop him from flirting. Yet his rakish, good-natured charm made it impossible for Leah to feel offended or repulsed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Okay, Grady,\" she smiled naturally. Her light brown hair caught the golden fire of the sunlight streaming through the windows.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He studied the streaks of gold for a second, then shifted his gaze to her classic profile, partially outlined as she turned to him. None of her features was striking, not the arching curve of brow, nor the bright gleam in her hazel eyes or the healthy glow of her complexion. Yet the total picture was decidedly attractive.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"If you're calling me Grady,\" the pilot tipped his head to the side, \"I can't keep calling you Miss Talbot.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It's Leah,\" answering the question he had only implied.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Tell me, Leah, are you a friend of Reilly's?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Reilly is Mr. Smith?\" A brow arched briefly to confirm her guess.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Obviously you don't know him,\" Grady chuckled. \"If you aren't a friend of Reilly's then what's taking you out to the middle of Nevada's nowhere?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I'm going to see my brother—providing your Mr. Smith shows up,\" Leah added wryly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Reilly is not anybody's Mr. Smith.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The dry undertone of his voice aroused Leah's curiosity. \"It sounds as though you know him quite well.\" Tactfully she pried for more information about her mysterious, and late, flying companion.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The pilot took a long, considering breath and leaned against the back cushion of the couch. \"I think the whole point is just the opposite. I doubt if anyone knows Reilly 'quite well.' He's a law unto himself, a lone wolf. He's part Indian, which may account for it.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Oh, I see,\" Leah murmured. \"Why is he going to Austin?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Business. He has connections with some of the mining interests around Austin and Tonopah. I usually fly him to one place or the other,\" was the reply.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fleetingly Leah wondered if this Reilly Smith worked for the same company that her brother Lonnie did. It was also entirely possible that he worked for one of their competitors. No matter, Leah shrugged inwardly. The only thing she was really interested in was when was Mr. Reilly Smith going to show up.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Do you live here in Las Vegas?\" Grady changed the subject to one that interested him more.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes.\" Before the usual question could be asked, Leah added, \"I'm a secretary to one of the executives of a local bank,\" and hoped Grady wouldn't add the usual comment that she would look good in one of the chorus lines that were the trademark of the lavish shows at the hotels on the strip.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"And your brother lives in Austin?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Only for the time being.\" Leah went on to explain his temporary assignment in Austin.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Has it been a while since you've seen him?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No, we were together at Christmas, but tomorrow is his birthday and I wanted to surprise him.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You must think a lot of him to go to all this expense,\" Grady observed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Lonnie and I are very close,\" agreed Leah.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Left unspoken were the details of her hopscotch childhood, skipping from one end of the world to the other. Under those circumstances, it was natural that she and Lonnie would be close. Despite the years that separated their ages, they were like twins.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What's your boyfriend have to say about all this? And don't tell me a girl like you doesn't have at least one boyfriend,\" the pilot teased with a knowing wink.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Let's just say that he questioned my sanity.\" A self-mocking laugh accompanied her reply as Leah remembered Marv's reaction.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He too worked in the accounting department of the same bank as she did. She hadn't decided yet where their relationship was going, so for want of a better word, she accepted the classification of Marv as her boyfriend.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In truth, none of her co-workers nor her roommate Nancy had actually encouraged the trip. They had all claimed that they understood her desire to see her brother again, but none of them seemed to think it was"), _c('span', {
    staticClass: "s1"
  }), _vm._v("wise to spend all of her savings for that goal.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Of course, they didn't seem to possess that close feeling of kinship with their brothers or sisters. If she had been spending the money to see a boyfriend, they probably wouldn't have questioned her decision. But a brother! The thought brought a wry smile to her mouth.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Your boyfriend was probably jealous that you weren't spending the weekend with him. I would be.\" Again Grady ran an admiring eye over her features.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Leah darted a quick glance at the wall clock. \"I'm beginning to think I won't be going anywhere this weekend,\" she sighed."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Reaching into her bag, she removed the opened pack of cigarettes and tapped out a filter-tip. As she started to search for the lighter, a flame sprang from the match in Grady's hand. She smiled her thanks and placed the cigarette between her peach-tinted lips, bending her head toward the flame.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Don't worry, Reilly will be here. If there was a question that he might not make it, he would have said so when he called earlier,\" the pilot assured her. \"In the meantime, why don't I take your luggage out to the plane and stow it in the baggage compartment?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Okay,\" Leah agreed. \"At least, I'll be one step closer to leaving.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("With a cheering smile, Grady patted her knee. \"Don't give up. We'll make it off the ground yet.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then he was picking up her blue weekender bag and the cosmetic case and walking toward the door leading to the hangar apron. With his departure, the minutes started to drag again.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The smoke from her cigarette spiralled above her head. Inhaling briefly on the filter-tip, Leah exhaled more smoke impatiently. The blue-gray cloud swirled upward.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The outside door opened. Her gaze swung indifferently toward the sound, expecting to see the pilot returning. It was a stranger who entered.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her mind had a preconceived idea of what Reilly Smith would look like—in his late forties, a supposition based on the belief that only an older, senior member of a mining team would charter an aircraft, short and stocky in build.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("This man didn't meet the description. He was six foot, leanly built but not slender and roughly ten years younger, in his mid-thirties. Jet black hair framed the boldly defined features of his bronzed tan face, prominent cheekbones leanly hollowing to powerful jawline. A face carved by the wind and sun.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("His dress was a casual leisure suit of rugged brown denim. A complementing shirt patterned in yellow and brown was open at the throat revealing the large nugget of turquoise attached to the beaten silver choker around his neck.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Despite this contrast between the man and her image, Leah was certain this was Reilly Smith. The quiet pride of his carriage, the sensation of aloofness, and the effortless, animal stride convinced her she was right.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Mary, the dark-haired receptionist, confirmed it. \"Finally you arrive, Mr. Smith!\" Her hands rested akimbo on her hips. \"Miss Talbot was about to decide you were a figment of her imagination.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("For the first time since entering the waiting lounge, his gaze acknowledged her presence in the room. His eyes were startlingly green, the smooth, impenetrable color of jade.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A disturbing shiver of awareness trembled through Leah as his cool gaze appraised her assets, admired them openly, then smoothly dismissed them in favor of the business at hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I was delayed,\" he said, which was neither an explanation nor an apology. \"My cases are sitting outside. Are you ready to leave, Miss Talbot?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("After waiting for going on three hours, Leah marvelled that he had the nerve to ask if she was ready! Sharply snubbing out her cigarette in the ashtray, she suppressed the impulse to remind him that he was the one who was late.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She kept her reply to a calm, \"My luggage is already in the plane, Mr. Smith.\" But the clasp of her handbag snapped shut rather loudly as she closed it and rose to her feet.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Stepping outside the building, a desert wind tugged at the hem of her camel-colored skirt, briefly lifting it to reveal a shapely leg. Leah held the open front of her matching tunic-styled waistcoat together with one hand while her other hand carrying the bag tried to keep the teasing wind from billowing her skirt.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As an afterthought, she realized that she probably should have worn slacks. Habits die hard, and she had lived in too many foreign countries where slacks on women were viewed with disfavor.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her shoes clicked loudly on the concrete while the man walking beside her made barely any sound at all. A sideways glance noticed that her heels didn't gain her much height. The top of her head came somewhere around his chin.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Automatically her gaze slid to the left hand carrying his bags. There was no wedding band on his finger. Somehow Leah had known there wouldn't be—perhaps because of Grady's statement that Reilly Smith was a lone wolf.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shifting her gaze straight ahead, Leah mused silently that there were probably a lot of girls who would like to change his status. He was a compellingly handsome man. Not that it mattered to her. She was making this trip to see her brother.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A few yards ahead, Grady was standing beside the orange and white wing of a Cessna 310. The twin engine plane looked sleek and racy. A smile flashed across the pilot's face as he saw their approach.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Didn't I tell you he'd make it, Leah?\" he declared in a hearty voice, then to the man at her side, \"Hello, Reilly.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Hello, Grady.\" It was a warm and friendly voice, unlike the impersonal tone Leah had heard earlier. A brisk handshake followed the exchange of greetings.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Let me stow your gear.\" Grady reached for the two bags gripped in the man's left hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I'll take the briefcase on board.\" Reilly Smith relinquished only the larger of the two bags, retaining the attaché case. His green eyes made an arc in the deepening lavender sky. A single star winked feebly in the purple twilight. \"What's it look like up ahead, Grady?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The pilot briefly scanned the sky, then shrugged and returned his attention to his passengers. \"There's a front moving in. We still have a chance of reaching Austin before it does. If not, it might get a little rough, but we'll make it.\" With his free hand, Grady motioned toward the open door of the plane. \"Climb aboard.\""), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The two small steps made it easy for Leah to climb on the wing even in her skirt. Maneuvering past the front seat to the second seats was more awkward. Reilly Smith followed with an ease that she envied.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He sat down in the seat beside her. Considering the apparent friendliness between himself and the pilot, Leah had partially expected him to sit in front with Grady. As she fastened her seat belt, she noticed the brief case he"), _c('span', {
    staticClass: "s2"
  }), _vm._v("had brought on board and realized he probably intended to work.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Grady climbed agilely aboard and swung himself into the pilot's seat directly ahead of Leah. His quick glance encompassed both of them before he buckled his seat belt.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Did you two introduce yourselves?\" The question didn't break the rhythm of his pre-flight checklist.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"More or less,\" Leah answered.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"She's flying to Austin to visit her brother.\" The information was given as the first of the plane's engines growled to life, the propeller hesitating, then spinning into a blur."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Leah cast a sideways glance at her companion. \"My brother works for a mining company. He's part of a team that's been temporarily assigned to survey the Austin area.\" This seemed like an excellent opportunity to see if Reilly Smith was a member of the same company or with a rival firm. \"Grady mentioned that you had connections with some mining interests. Perhaps you know my brother. His name is Lonnie Talbot.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was a disconcerting levelness to his jade eyes as they briefly met her look. The grooves at each side of his hard mouth deepened into a faint smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No, I don't know him.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The roar of both engines made conversation impossible. Leah was forced to set aside her curiosity for the time being. At least she felt secure in the assumption that Reilly Smith did not work for the same company as her brother.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In the pilot's seat, Grady was on the radio. \"McCarren Ground Control, this is 92 George requesting taxi instructions.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Excitement danced in her veins. After all the waiting, she was finally on her way. Looking out the window, Leah smiled with secret amusement at what Lonnie's reaction would be when he learned she had flown to be with him on his birthday.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Blue lights flashed outside her window as the plane rolled along the taxi strip to the airport runway. At the edge of the runway, the engines roared with thundering force as Grady made his run-up. Then the tower radioed permission for them to take off.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Grady half-looked over his shoulder, a grin on his otherwise serious face. \"Now"), _c('span', {
    staticClass: "s1"
  }), _vm._v("we'll get this bird off the ground.\""), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Smoothly the plane pivoted on to the runway, the engines building power. Leah felt the surge of acceleration as the brakes were released and the throttle opened to full power. The nose was lifted off the ground. Seconds later the plane was airborne and climbing, the landing gear thumping into the belly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Outside her window, Leah could see the blaze of city lights in the pre-night darkness. The brilliant neon lights of the hotels and casinos on Las Vegas's famous strip were like an iridescently colored ribbon.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cool night air from the vent above her head ruffled the light brown wings of her hair. The infra-red lights on the instrument panel kept the darkness at bay, those lights and the reading light shining down on the seat next to hers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her fellow passenger was not gazing at the diminishing world below them, Leah noticed. His briefcase was opened on his lap. Common courtesy ruled that she shouldn't try to resume their conversation when he was obviously working. The urge was strong to look over his shoulder and see the contents of the"), _c('span', {
    staticClass: "s2"
  }), _vm._v("papers he was studying. She resisted, averting her attention again to the window. Eventually the only thing she could see was her own reflection.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She considered taking out the paperback book she had brought in her bag, then decided against it. She was too intent on reaching her destination to concentrate on reading.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The airplane levelled off. Grady partially turned in his seat. \"Want to sit up front with me for a while, Leah?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Thank you, yes,\" she agreed readily. Conversation would make the time pass faster.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As Leah unbuckled her seat belt, Grady smiled crookedly at the man sitting next to her. \"You don't have any objections to the switch, do you, Reilly?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"None at all.\" There was a faint mockery in the reply as silently laughing green eyes flicked a glance at Leah.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Briefly she wondered if Reilly Smith thought she was making a play for the pilot. Surely he could see that Grady was old enough to be her father.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Don't bump into any of the controls,\" Grady cautioned as Leah crouched in a half-erect position to negotiate the tiny aisle way to the empty front seat.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A helping hand gripped her elbow. With faint surprise, she realized it belonged to Reilly Smith. His touch was pleasantly strong and reassuring, but brief.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Dodging the control panel near the floor, Leah slid on to the right front seat, straightening her skirt over her knees. The change of seats had been accomplished without mishap despite the close quarters.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Thank you,\" she offered over her shoulder for the steadying hand. \"I hope Grady and I talking won't disturb your work, Mr. Smith.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"As a matter of fact, I think I'll quit for a while and get some sleep.\" The snap of the briefcase lid followed his statement.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("When the reading light went off, Leah fleetingly wished she had not moved from her seat. She would have liked to satisfy some of her curiosity about this Reilly Smith.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It's amazing.\" Grady shook his head, a wry smile on his face.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What is?\" Leah returned blankly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Him.\" With a backward nod of his head, the pilot indicated the man in the seat behind Leah.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Self-consciously she was aware that Grady's voice carried easily to the man. She glanced over her shoulder to see Reilly Smith's reaction to the comment. He was leaning back in his seat, eyes closed. His chest moved in an even rhythm.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"He's already asleep,\" Grady sighed. \"He just closes his eyes. No tossing, no turning, just sleep.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Must be nice,\" Leah agreed, settling back into her seat. She glanced around at the instrument dials illuminated by the infra-red light. \"Is the plane on auto-pilot now?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yup.\" But Leah noticed the automatic way Grady kept checking the panel. \"Have you ever been in the front seat of a private plane before?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"My dad has taken me up several times, but never in anything as sophisticated as this,\" she admitted.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Modern avionics courtesy of the computer age.\" Grady smiled. \"It does everything but land the plane, and nearly does that. It's great, but all equipment breaks down eventually. Let's not talk about flying, though—I hear that all day long. Considering your young years and the length of this flight, I think there's time for you to tell me about your childhood.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It won't take long,\" Leah laughed softly. \"My brother and I were Air Force brats.\" She added a sketchy outline of her childhood life, moving from air base to air base.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"How in heaven's name did you wind up in Las Vegas?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"The usual way. Dad was transferred to Nellis Air Force Base when I was in high school. I had graduated and just started a secretarial course when his orders came through for Alaska. I wanted to finish my training, so for that reason, and because it was time to leave the nest, I stayed.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"The lure of the bright lights?\" Grady mocked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Not a bit. I'm very happy being a secretary,\" she stated positively. \"I have no desire to be an entertainer of any sort. The work is too hard and the hours are too demanding.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That's true enough,\" he agreed. \"Are you like the rest of the Las Vegas residents, rarely stepping inside a gambling casino unless you work there?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Exactly!\" Then she qualified her answer. \"When new shows open or a favorite celebrity of mine is appearing, I do go then. But on the whole, I leave the casinos for the tourists and the gamblers.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Say,\" Grady paused, turning a curious look to her, \"did you tell me that you were in the South Pacific for a time?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Guam and Hawaii.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I was there when I was in the service—and I'm not going to tell you how long ago that was!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A steady flow of questions"), _c('span', {
    staticClass: "s2"
  }), _vm._v("began as Grady probed her memory to see if she had been to places he had visited, then compared her descriptions to what he remembered.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Gradually they talked themselves out and drifted into silence. Leah gazed beyond her window reflection at the star-sprinkled sky in the east. She felt sublimely relaxed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"If you feel like nodding off,\" Grady spoke quietly, \"you can crawl back to your old seat. At least there, you can stretch your legs out without fear of bumping any controls.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("With a contented sigh, she agreed. \"I think I'll do that.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was a bit easier negotiating the tiny aisle, although Leah took care not to waken the sleeping Reilly. As she turned to slide into her seat, she noticed the inky blankness of the sky directly ahead.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It's very dark ahead, isn't it?\" she questioned Grady softly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It must be frontal system. I think I'll check with the weather bureau and see if I can get an update on it.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He made the call while she buckled her seat belt. The answering transmission didn't carry clearly to her, but Grady passed the message back.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"The front beat us to Austin. You'd better buckle in tight—it might get a little rough.\" Then he glanced over his shoulder at the sleeping figure. \"Reilly!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I heard you,\" came the quiet reply. With calm deliberation, Reilly straightened and tightened his seat belt.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I thought you were asleep.\" Leah spoke without thinking.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I was.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was not a trace of sleepiness in his voice. She decided that he wakened as quickly as he went to sleep.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c1ff874","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section5.vue
// module id = 78
// module chunks = 0